import { render, staticRenderFns } from "./ActivitiesNew.vue?vue&type=template&id=7be1c4b0&"
import script from "./ActivitiesNew.vue?vue&type=script&lang=js&"
export * from "./ActivitiesNew.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports